import React from 'react';
import AutomationCreate from './AutomationCreate';
import { flatten } from 'lodash';
import { useParams } from 'react-router-dom';

function CreateAssessmentWrapper({
    companyId,
    parentPath,
    customBackUrl,
    editingAssessment,
    isScorm,
    recommendationMode,
}) {
    const { listId } = useParams();

    const mapVideosToIds = (videos) =>
        flatten(Object.values(videos)).map((x) => x.id);

    const recommendations = listId
        ? editingAssessment._rawData.recommendationsByList?.[listId]
        : editingAssessment.recommendations;

    const subjects = mapVideosToIds(recommendations?.videos || {});

    const lists = listId
        ? [{ id: parseInt(listId) }]
        : editingAssessment.selectedUserListsIds.map((x) => ({ id: x }));

    const initialData = {
        subjects,
        lists,
    };

    if (recommendations?.custom) {
        initialData.definition = {
            disableSyncLists: true,
            recommendationSourceAssessmentId: editingAssessment.id,
            recommendationScoreThreshold: recommendations.scoreThreshold,
        };
    }

    return (
        <AutomationCreate
            companyId={companyId}
            parentPath={parentPath}
            customBackUrl={customBackUrl}
            initialData={initialData}
            recommendationMode={recommendationMode}
            isScorm={isScorm}
        />
    );
}

export default CreateAssessmentWrapper;
